
//Error Messages
export const VALIDATION_MSG ={
    APPLICATION_REQUIRED : "Application selection is required.",
    INTERNAL_ROLE_NAME_REQUIRED : "Internal Role Name is required.",
    EMAIL_REQUIRED : "Email is required.",
    EMAIL_INVALID : "Email is Invalid.",
    DOB_REQUIRED: "Date of Birth is required.",
    ID_REQUIRED: "Identification No. is required.",
    GENDER_REQUIRED: "Gender is required.",
    FIRST_NAME_REQUIRED : "First Name is required.",
    LAST_NAME_REQUIRED : "Last Name is required.",
    EFFECTIVE_START_DATE_REQUIRED : "Effective Start Date is required.",
    START_DATE_LATER_THAN : "Please select a start date from today onwards.",
    FIRSTNAME_REQUIRED : "First Name is required.",
    LASTNAME_REQUIRED : "Last Name is required.",
    USERNAME_REQUIRED : "Username is required.",
    USERGROUP_NAME_REQUIRED : "User Group Name is required.",
    PERMISSION_NAME_REQUIRED : "Permission Name is required.",
    PERMISSION_TYPE_REQUIRED : "Permission Type is required.",
    DESCRIPTION_REQUIRED : "Description is required.",
    DISPLAY_ROLE_NAME_REQUIRED : "Display Role Name is required.",
    APPROVAL_REQUIRED : "Approval is required.",
    REJECTION_REASON_REQUIRED : "Rejection Reason is required.",
    USER_TYPE_REQUIRED : "User Type is required.",
    IS_MONITORED_REQUIRED : "Monitor Permission is required.",
    END_DATE_NOT_BEFORE_START_DATE : "Effective End Date should not be before Effective Start Date."
}

export const IDENTITY_URL = process.env.REACT_APP_AUTHORITY_URL;
export const CLIENT_URL = process.env.REACT_APP_AUTHORITY_POST_LOGOUT_REDIRECT_URL;

export const REDIRECT_URI = "redirectUri";

export const LABEL_TEXT = {
    USER_TYPE: "User Type",
    USERNAME: "Username",
    FIRST_NAME: "First Name",
    MIDDLE_NAME: "Middle Name",
    LAST_NAME: "Last Name",
    DOB: "Date Of Birth",
    EMAIL: "Email",
    INTERNAL_GROUP_NAME: "Group Name",
    PERMISSION_NAME: "Permission Name",
    PERMISSION_TYPE: "Permission Type",
    NID : "Identification Number",
    GENDER : "Gender",
    DESCRIPTION : "Description",
    ROLE_NAME : "Role Name",
    DISPLAY_ROLE_NAME : "Display Name",
    ROLE_TO_PERMISSION : "Select Permission For Role",
    USER_GROUP : "User Group",
    ROLE_TO_USERGROUP : "Select Roles For User Group",
    ROLE_TO_USER : "Select Role For User",
    USERGROUP_TO_USER : "Select Users For User Group",
    USER_GROUP_NAME : "User Group Name"
};
